const stockData = {
  MSFT: 'Microsoft Corp',
  AAPL: 'Apple Inc.',
  NVDA: 'Nvidia Corp',
  AMZN: 'Amazon.com Inc.',
  META: 'Meta Platforms, Inc. Class A',
  GOOGL: 'Alphabet Inc. Class A',
  GOOG: 'Alphabet Inc. Class C',
  BRK_B: 'Berkshire Hathaway Class B',
  LLY: 'Eli Lilly & Co.',
  AVGO: 'Broadcom Inc.',
  JPM: 'Jpmorgan Chase & Co.',
  XOM: 'Exxon Mobil Corporation',
  TSLA: 'Tesla, Inc.',
  UNH: 'Unitedhealth Group Incorporated',
  V: 'Visa Inc.',
  PG: 'Procter & Gamble Company',
  MA: 'Mastercard Incorporated',
  JNJ: 'Johnson & Johnson',
  MRK: 'Merck & Co., Inc.',
  HD: 'Home Depot, Inc.',
  COST: 'Costco Wholesale Corp',
  ABBV: 'Abbvie Inc.',
  CVX: 'Chevron Corporation',
  CRM: 'Salesforce, Inc.',
  BAC: 'Bank of America Corporation',
  WMT: 'Walmart Inc.',
  AMD: 'Advanced Micro Devices',
  NFLX: 'Netflix Inc',
  PEP: 'Pepsico, Inc.',
  KO: 'Coca-Cola Company',
  TMO: 'Thermo Fisher Scientific, Inc.',
  WFC: 'Wells Fargo & Co.',
  LIN: 'Linde Plc',
  ADBE: 'Adobe Inc.',
  DIS: 'The Walt Disney Company',
  MCD: 'Mcdonald\'s Corporation',
  CSCO: 'Cisco Systems, Inc.',
  ACN: 'Accenture Plc',
  ABT: 'Abbott Laboratories',
  ORCL: 'Oracle Corp.',
  QCOM: 'Qualcomm Inc.',
  INTU: 'Intuit Inc.',
  GE: 'General Electric Company',
  CAT: 'Caterpillar Inc.',
  VZ: 'Verizon Communications',
  AMAT: 'Applied Materials Inc.',
  DHR: 'Danaher Corporation',
  TXN: 'Texas Instruments Incorporated',
  IBM: 'International Business Machines Corporation',
  COP: 'Conocophillips',
  CMCSA: 'Comcast Corp',
  PM: 'Philip Morris International Inc.',
  INTC: 'Intel Corp',
  UNP: 'Union Pacific Corp.',
  NOW: 'Servicenow, Inc.',
  AMGN: 'Amgen Inc',
  UBER: 'Uber Technologies, Inc.',
  PFE: 'Pfizer Inc.',
  NEE: 'Nextra Energy, Inc.',
  GS: 'Goldman Sachs Group Inc',
  AXP: 'American Express Company',
  RTX: 'Rtx Corporation',
  SPGI: 'S&p Global Inc.',
  LOW: 'Lowe\'s Companies Inc',
  ISRG: 'Intuitive Surgical Inc.',
  HON: 'Honeywell International, Inc.',
  ELV: 'Elevance Health, Inc.',
  ETN: 'Eaton Corporation, Plcs',
  MU: 'Micron Technology, Inc.',
  PGR: 'Progressive Corporation',
  BKNG: 'Booking Holdings Inc.',
  T: 'At&t Inc.',
  LRCX: 'Lam Research Corp.',
  C: 'Citigroup Inc.',
  MS: 'Morgan Stanley',
  NKE: 'Nike, Inc.',
  SYK: 'Stryker Corporation',
  SCHW: 'The Charles Schwab Corporation',
  TJX: 'Tjx Companies, Inc.',
  BSX: 'Boston Scientific Corp.',
  UPS: 'United Parcel Service, Inc. Class B',
  BLK: 'Blackrock, Inc.',
  MDT: 'Medtronic Plc',
  CI: 'The Cigna Group',
  DE: 'Deere & Company',
  VRTX: 'Vertex Pharmaceuticals Inc.',
  ADP: 'Automatic Data Processing',
  LMT: 'Lockheed Martin Corp.',
  CB: 'Chubb Limited',
  SBUX: 'Starbucks Corp.',
  MMC: 'Marsh & Mclennan Companies, Inc.',
  ADI: 'Analog Devices, Inc.',
  BA: 'Boeing Company',
  PLD: 'Prologis, Inc.',
  MDLZ: 'Mondelez International, Inc. Class A',
  REGN: 'Regeneron Pharmaceuticals Inc.',
  FI: 'Fiserv, Inc.',
  KLAC: 'Kla Corporation',
  PANW: 'Palo Alto Networks, Inc.',
  BMY: 'Bristol-Myers Squibb Co.',
  BX: 'Blackstone Inc.',
  TMUS: 'T-Mobile Us, Inc.',
  CMG: 'Chipotle Mexican Grill, Inc.',
  CVS: 'Cvs Health Corporation',
  GILD: 'Gilead Sciences Inc',
  SO: 'The Southern Company',
  SNPS: 'Synopsys Inc',
  AMT: 'American Tower Corporation',
  EOG: 'Eog Resources, Inc.',
  WM: 'Waste Management, Inc.',
  MO: 'Altria Group, Inc.',
  CME: 'Cme Group Inc.',
  DUK: 'Duke Energy Corporation',
  TGT: 'Target Corporation',
  ICE: 'Intercontinental Exchange Inc.',
  CDNS: 'Cadence Design Systems',
  CL: 'Colgate-Palmolive Company',
  MPC: 'Marathon Petroleum Corporation',
  SHW: 'The Sherwin-Williams Company',
  APH: 'Amphenol Corporation',
  MCK: 'Mckesson Corporation',
  ABNB: 'Airbnb, Inc. Class A',
  FCX: 'Freeport-Mcmoran Inc.',
  PH: 'Parker-Hannifin Corporation',
  ZTS: 'Zoetis Inc.',
  SLB: 'Schlumberger Limited',
  TDG: 'Transdigm Group Incorporated',
  EQIX: 'Equinix, Inc. Reit',
  NOC: 'Northrop Grumman Corp.',
  PYPL: 'Paypal Holdings, Inc.',
  TT: 'Trane Technologies Plc',
  ITW: 'Illinois Tool Works Inc.',
  PSX: 'Phillips 66',
  CSX: 'Csx Corporation',
  BDX: 'Becton, Dickinson and Co.',
  ANET: 'Arista Networks',
  GD: 'General Dynamics Corporation',
  PXD: 'Pioneer Natural Resource Co.',
  USB: 'U.S. Bancorp',
  EMR: 'Emerson Electric Co.',
  ORLY: 'O reilly Automotive, Inc.',
  PNC: 'Pnc Financial Services Group',
  HCA: 'Hca Healthcare, Inc.',
  FDX: 'Fedex Corporation',
  NXPI: 'Nxp Semiconductors N.v.',
  AON: 'Aon Plc Class A',
  CEG: 'Constellation Energy Corporation',
  MAR: 'Marriot International Class A',
  MCO: 'Moodys Corporation',
  PCAR: 'Paccar Inc',
  MSI: 'Motorola Solutions, Inc.',
  CTAS: 'Cintas Corp',
  ROP: 'Roper Technologies, Inc.',
  VLO: 'Valero Energy Corporation',
  ECL: 'Ecolab, Inc.',
  COF: 'Capital One Financial',
  NSC: 'Norfolk Southern Corp.',
  EW: 'Edwards Lifesciences Corp',
  DXCM: 'Dexcom, Inc.',
  GM: 'General Motors Company',
  AIG: 'American International Group, Inc.',
  APD: 'Air Products & Chemicals, Inc.',
  WELL: 'Welltower Inc.',
  HLT: 'Hilton Worldwide Holdings Inc.',
  F: 'Ford Motor Company',
  AJG: 'Arthur J. Gallagher & Co.',
  AZO: 'Autozone, Inc.',
  MMM: '3m Company',
  TFC: 'Truist Financial Corporation',
  CARR: 'Carrier Global Corporation',
  NEM: 'Newmont Corporation',
  MCHP: 'Microchip Technology Inc',
  TRV: 'The Travelers Companies, Inc.',
  CPRT: 'Copart Inc',
  WMB: 'Williams Companies Inc.',
  OKE: 'Oneok, Inc.',
  URI: 'United Rentals, Inc.',
  SPG: 'Simon Property Group, Inc.',
  ADSK: 'Autodesk Inc',
  KMB: 'Kimberly-Clark Corp.',
  AEP: 'American Electric Power Company, Inc.',
  SRE: 'Sempra',
  ALL: 'The Allstate Corporation',
  OXY: 'Occidental Petroleum Corporation',
  ROST: 'Ross Stores Inc',
  O: 'Realty Income Corporation',
  HES: 'Hess Corporation',
  AFL: 'Aflac Inc.',
  MET: 'Metlife, Inc.',
  JCI: 'Johnson Controls International Plc',
  TEL: 'Te Connectivity Ltd',
  BK: 'Bank of New York Mellon Corporation',
  DHI: 'D.R. Horton Inc.',
  NUE: 'Nucor Corporation',
  DLR: 'Digital Realty Trust, Inc.',
  IQV: 'Iqvia Holdings Inc.',
  D: 'Dominion Energy, Inc',
  STZ: 'Constellation Brands, Inc.',
  GWW: 'W.W. Grainger, Inc.',
  FIS: 'Fidelity National Information Services, Inc.',
  AMP: 'Ameriprise Financial, Inc.',
  LULU: 'Lululemon Athletica Inc.',
  AME: 'Ametek, Inc.',
  PSA: 'Public Storage',
  CCI: 'Crown Castle Inc.',
  FTNT: 'Fortinet, Inc.',
  IDXX: 'Idexx Laboratories Inc',
  GIS: 'General Mills, Inc.',
  CNC: 'Centene Corporation',
  GEV: 'Ge Vernova Inc.',
  PRU: 'Prudential Financial, Inc.',
  COR: 'Cencora, Inc.',
  A: 'Agilent Technologies Inc.',
  YUM: 'Yum! Brands, Inc.',
  CMI: 'Cummins Inc.',
  SMCI: 'Super Micro Computer, Inc.',
  DOW: 'Dow Inc.',
  RSG: 'Republic Services Inc.',
  LHX: 'L3harris Technologies, Inc.',
  MNST: 'Monster Beverage Corporation',
  PAYX: 'Paychex Inc',
  FAST: 'Fastenal Co',
  SYY: 'Sysco Corporation',
  CTVA: 'Corteva, Inc.',
  HUM: 'Humana Inc.',
  LEN: 'Lennar Corporation Class A',
  OTIS: 'Otis Worldwide Corporation',
  EXC: 'Exelon Corporation',
  IR: 'Ingersoll Rand Inc.',
  PWR: 'Quanta Services, Inc.',
  FANG: 'Diamondback Energy, Inc.',
  MLM: 'Martin Marietta Materials',
  CSGP: 'Costar Group Inc',
  MSCI: 'Msci, Inc.',
  KR: 'The Kroger Co.',
  GEHC: 'Ge Healthcare Technologies Inc.',
  PCG: 'Pg&e Corporation',
  KMI: 'Kinder Morgan, Inc.',
  KDP: 'Keurig Dr Pepper Inc.',
  ODFL: 'Old Dominion Freight Line',
  MRNA: 'Moderna, Inc.',
  IT: 'Gartner, Inc.',
  HAL: 'Halliburton Company',
  ACGL: 'Arch Capital Group Ltd',
  VMC: 'Vulcan Materials Company',
  PEG: 'Public Service Enterprise Group Incorporated',
  DVN: 'Devon Energy Corporation',
  EL: 'The Estee Lauder Companies Inc. Class A',
  CTSH: 'Cognizant Technology Solutions',
  BKR: 'Baker Hughes Company',
  KVUE: 'Kenvue Inc.',
  CDW: 'Cdw Corporation',
  ADM: 'Archer Daniels Midland Company',
  ED: 'Consolidated Edison, Inc.',
  GPN: 'Global Payments, Inc.',
  RCL: 'Royal Caribbean Group',
  VRSK: 'Verisk Analytics, Inc.',
  DAL: 'Delta Air Lines, Inc.',
  ROK: 'Rockwell Automation, Inc.',
  DD: 'Dupont De Nemours, Inc.',
  MPWR: 'Monolithic Power Systems, Inc.',
  DFS: 'Discover Financial Services',
  DG: 'Dollar General Corp.',
  XYL: 'Xylem Inc',
  EA: 'Electronic Arts Inc',
  KHC: 'The Kraft Heinz Company',
  PPG: 'Ppg Industries, Inc.',
  XEL: 'Xcel Energy, Inc.',
  HIG: 'The Hartford Financial Services Group, Inc.',
  VICI: 'Vici Properties Inc.',
  FICO: 'Fair Isaac Corporation',
  BIIB: 'Biogen Inc.',
  WAB: 'Wabtec Inc.',
  TSCO: 'Tractor Supply Co',
  ON: 'On Semiconductor Corp',
  ANSS: 'Ansys Inc',
  EXR: 'Extra Space Storage, Inc.',
  HSY: 'The Hershey Company',
  EFX: 'Equifax, Incorporated',
  WST: 'West Pharmaceutical Services, Inc.',
  EIX: 'Edison International',
  RMD: 'Resmed Inc.',
  AVB: 'Avalonbay Communities, Inc.',
  FTV: 'Fortive Corporation',
  MTD: 'Mettler-Toledo International',
  EBAY: 'Ebay Inc',
  WTW: 'Willis Towers Watson Public Limited Companys',
  CHD: 'Church & Dwight Co., Inc.',
  TRGP: 'Targa Resources Corp.',
  KEYS: 'Keysight Technologies, Inc.',
  WEC: 'Wec Energy Group, Inc.',
  CBRE: 'Cbre Group, Inc.',
  CHTR: 'Charter Comm Inc Del Cl a',
  CAH: 'Cardinal Health, Inc.',
  DLTR: 'Dollar Tree Inc.',
  HWM: 'Howmet Aerospace Inc.',
  LYB: 'Lyondellbasell Industries N.v. Class A',
  FITB: 'Fifth Third Bancorp',
  DOV: 'Dover Corporation',
  ZBH: 'Zimmer Biomet Holdings, Inc.',
  NVR: 'Nvr, Inc.',
  HPQ: 'Hp Inc.',
  MTB: 'M&t Bank Corp.',
  TROW: 'T Rowe Price Group Inc',
  PHM: 'Pultegroup, Inc.',
  GLW: 'Corning Incorporated',
  AWK: 'American Water Works Company, Inc',
  BR: 'Broadridge Financial Solutions Inc',
  WY: 'Weyerhaeuser Company',
  RJF: 'Raymond James Financial, Inc.',
  DTE: 'Dte Energy Company',
  NDAQ: 'Nasdaq, Inc.',
  BLDR: 'Builders Firstsource, Inc.',
  ETR: 'Entergy Corporation',
  TTWO: 'Take-Two Interactive Software Inc',
  GPC: 'Genuine Parts Company',
  STT: 'State Street Corporation',
  IRM: 'Iron Mountain Inc.',
  WDC: 'Western Digital Corp.',
  EQR: 'Equity Residential',
  ALGN: 'Align Technology Inc',
  GRMN: 'Garmin Ltd',
  CPAY: 'Corpay, Inc.',
  HPE: 'Hewlett Packard Enterprise Company',
  AXON: 'Axon Enterprise, Inc.',
  HUBB: 'Hubbell Incorporated',
  IFF: 'International Flavors & Fragrances Inc.',
  PTC: 'Ptc, Inc',
  CTRA: 'Coterra Energy Inc.',
  SBAC: 'Sba Communications Corp',
  ES: 'Eversource Energy',
  NTAP: 'Netapp, Inc.',
  DECK: 'Deckers Outdoor Corp',
  VLTO: 'Veralto Corporation',
  BALL: 'Ball Corporation',
  MOH: 'Molina Healthcare, Inc.',
  BAX: 'Baxter International Inc.',
  STLD: 'Steel Dynamics Inc',
  ULTA: 'Ulta Beauty, Inc.',
  PPL: 'Ppl Corporation',
  FE: 'Firstenergy Corp.',
  STE: 'Steris Plc',
  APTV: 'Aptiv Plc',
  INVH: 'Invitation Homes Inc.',
  HBAN: 'Huntington Bancshares Inc',
  BRO: 'Brown & Brown, Inc.',
  AEE: 'Ameren Corporation',
  CBOE: 'Cboe Global Markets, Inc.',
  OMC: 'Omnicom Group Inc.',
  TYL: 'Tyler Technologies, Inc.',
  ILMN: 'Illumina Inc.',
  MKC: 'Mccormick & Company, Incorporated Non-Vtg Cs',
  DRI: 'Darden Restaurants, Inc.',
  FSLR: 'First Solar, Inc.',
  CINF: 'Cincinnati Financial Corp',
  CNP: 'Centerpoint Energy, Inc.',
  SYF: 'Synchrony Financial',
  WBD: 'Warner Bros. Discovery, Inc. Series a',
  CLX: 'Clorox Company',
  ARE: 'Alexandria Real Estate Equities, Inc.',
  WAT: 'Waters Corp',
  RF: 'Regions Financial Corp.',
  J: 'Jacobs Solutions Inc.',
  EXPE: 'Expedia Group, Inc.',
  COO: 'The Cooper Companies, Inc.',
  HOLX: 'Hologic Inc',
  PFG: 'Principal Financial Group, Inc.',
  TDY: 'Teledyne Technologies Incorporated',
  LDOS: 'Leidos Holdings, Inc.',
  CMS: 'Cms Energy Corporation',
  ATO: 'Atmos Energy Corporation',
  UAL: 'United Airlines Holdings, Inc.',
  AVY: 'Avery Dennison Corp.',
  VTR: 'Ventas, Inc.',
  TSN: 'Tyson Foods, Inc.',
  NTRS: 'Northern Trust Corp',
  DPZ: 'Dominos Pizza Inc.',
  STX: 'Seagate Technology Holdings Plcs',
  LH: 'Laboratory Corporation of America Holdings',
  LVS: 'Las Vegas Sands Corp.',
  IEX: 'Idex Corporation',
  TER: 'Teradyne, Inc.',
  TXT: 'Textron, Inc.',
  EQT: 'Eqt Corp',
  NRG: 'Nrg Energy, Inc.',
  EXPD: 'Expeditors International of Washington, Inc.',
  SWKS: 'Skyworks Solutions Inc',
  CFG: 'Citizens Financial Group, Inc.',
  MRO: 'Marathon Oil Corporation',
  LUV: 'Southwest Airlines Co.',
  VRSN: 'Verisign Inc',
  FDS: 'Factset Research Systems',
  ESS: 'Essex Property Trust, Inc.',
  WRB: 'W.R. Berkley Corporation',
  EG: 'Everest Group, Ltd.',
  MAS: 'Masco Corporation',
  K: 'Kellanova',
  AKAM: 'Akamai Technologies Inc',
  PKG: 'Packaging Corp of America',
  CCL: 'Carnival Corporation',

  CF: 'Cf Industries Holding, Inc.',
  CE: 'Celanese Corporation',
  JBL: 'Jabil Inc.',
  BG: 'Bunge Global Sa',
  DGX: 'Quest Diagnostics Inc.',
  ZBRA: 'Zebra Technologies Corporation',
  CAG: 'Conagra Brands, Inc.',
  MAA: 'Mid-America Apartment Communities, Inc.',
  TRMB: 'Trimble Inc.',
  ENPH: 'Enphase Energy, Inc.',
  BBY: 'Best Buy Company, Inc.',
  POOL: 'Pool Corporation',
  SNA: 'Snap-on Incorporated',
  NDSN: 'Nordson Corp',
  L: 'Loews Corporation',
  VTRS: 'Viatris Inc.',
  KEY: 'Keycorp',
  SWK: 'Stanley Black & Decker, Inc.',
  EPAM: 'Epam Systems, Inc.',
  ALB: 'Albemarle Corporation',
  JBHT: 'Jb Hunt Transport Services Inc',
  HST: 'Host Hotels & Resorts, Inc.',
  PNR: 'Pentair Plc',
  DOC: 'Healthpeak Properties, Inc.',
  AMCR: 'Amcor Plcs',
  LNT: 'Alliant Energy Corporation',
  WBA: 'Walgreens Boots Alliance, Inc.',
  RVTY: 'Revvity, Inc.',
  LYV: 'Live Nation Entertainment Inc.',
  ROL: 'Rollins, Inc.',
  KIM: 'Kimco Realty Corp.',
  JKHY: 'Henry (Jack) & Associates',
  EVRG: 'Evergy, Inc.',
  LW: 'Lamb Weston Holdings, Inc.',
  IPG: 'The Interpublic Group of Companies, Inc.',
  WRK: 'Westrock Company',
  SJM: 'The J.M. Smucker Company',
  TAP: 'Molson Coors Beverage Company Class B',
  CRL: 'Charles River Laboratories International, Inc.',
  IP: 'International Paper Co.',
  GEN: 'Gen Digital Inc.',
  UDR: 'Udr, Inc.',
  MGM: 'Mgm Resorts International',
  LKQ: 'Lkq Corporation',
  AES: 'Aes Corporation',
  PODD: 'Insulet Corporation',
  EMN: 'Eastman Chemical Company',
  NI: 'Nisource Inc.',
  QRVO: 'Qorvo, Inc.',
  JNPR: 'Juniper Networks Inc',
  HII: 'Huntington Ingalls Industries, Inc.',
  KMX: 'Carmax Inc.',
  ALLE: 'Allegion Public Limited Company',
  FFIV: 'F5, Inc.',
  CPT: 'Camden Property Trust',
  BBWI: 'Bath & Body Works, Inc.',
  HRL: 'Hormel Foods Corporation',
  AOS: 'A.O. Smith Corporation',
  CTLT: 'Catalent, Inc.',
  UHS: 'Universal Health Services, Inc. Class B',
  APA: 'Apa Corporation',
  MOS: 'The Mosaic Company',
  TECH: 'Bio-Techne Corp.',
  TFX: 'Teleflex Incorporated',
  REG: 'Regency Centers Corporation',
  HSIC: 'Henry Schein Inc',
  INCY: 'Incyte Genomics Inc',
  WYNN: 'Wynn Resorts Ltd',
  NWSA: 'News Corporation Class A',
  AAL: 'American Airlines Group Inc.',
  AIZ: 'Assurant, Inc.',
  DAY: 'Dayforce, Inc.',
  PAYC: 'Paycom Software, Inc.',
  TPR: 'Tapestry, Inc.',
  CPB: 'Campbell Soup Company',
  BXP: 'Boston Properties, Inc.',
  BF_B: 'Brown-Forman Corporation Class B',
  MTCH: 'Match Group, Inc',
  SOLV: 'Solventum Corporation',
  GNRC: 'Generac Holdings Inc',
  PNW: 'Pinnacle West Capital Corporation',
  HAS: 'Hasbro, Inc.',
  CHRW: 'C.H. Robinson Worldwide, Inc.',
  CZR: 'Caesars Entertainment, Inc.',
  ETSY: 'Etsy, Inc.',
  NCLH: 'Norwegian Cruise Line Holdings Ltd.',
  FOXA: 'Fox Corporation Class A',
  BWA: 'Borgwarner Inc.',
  MKTX: 'Marketaxess Holdings Inc.',
  FRT: 'Federal Realty Investment Trust',
  RHI: 'Robert Half Inc.',
  FMC: 'Fmc Corporation',
  DVA: 'Davita Inc.',
  BEN: 'Franklin Resources, Inc.',
  CMA: 'Comerica Incorporated',
  RL: 'Ralph Lauren Corporation',
  IVZ: 'Invesco Ltd',
  GL: 'Globe Life Inc.',
  PARA: 'Paramount Global Class B',
  BIO: 'Bio-Rad Laboratories, Inc.Class A',
  MHK: 'Mohawk Industries, Inc.',
  FOX: 'Fox Corporation Class B',
  NWS: 'News Corporation Class B',
  MSTR: 'MicroStrategy Incorporated',
  COIN: 'Coinbase Global Inc.',
  PLTR: 'Palantir Technologies Inc.',
  AI: 'C3.ai Inc.',
  TSM: 'Taiwan Semiconductor',
  BABA: 'Alibaba Group Holding Ltd.',
  SQ: 'Block Inc.',
  LYFT: 'Lyft Inc.',
  SNOW: 'Snowflake Inc.'
};

export default stockData;
  